import Support from '@/app/components/Support'
import Head from 'next/head'

export default function SupportPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Assistência Técnica</title>
        <meta name="description" content="Obtenha suporte técnico especializado da Azul Agro. Nossa equipe está pronta para ajudar você a otimizar suas operações agrícolas com soluções de alta performance. Descubra mais sobre nossos serviços de assistência técnica." />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/desktop/support/introSection.webp"} media="(min-width: 1140px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/tablet/support/introSection.webp"} media="(min-width: 540px) and (max-width: 1139px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/mobile/support/introSection.webp"} media="(max-width: 539px)" />
      </Head>
      <Support />
    </>
  )
}
